import { removeToken } from '@/utils/auth'
import { LazycatAccountCenter } from '@lazycatcloud/public-account'
import { Message } from 'element-ui'

const baseURL = `${process.env.VUE_APP_ACCOUNT_API_HOST || ''}/api`
const center = new LazycatAccountCenter({ baseURL })

const state = {
  id: '',
  nickname: '',
  avatar: '',
}

const mutations = {
  SET_ID: (state, id) => {
    state.id = id
  },
  SET_NAME: (state, name) => {
    state.nickname = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
}

const actions = {
  async login({ commit }, userInfo) {
    const { username, password } = userInfo
    let token = ""
    let user = null
    try {
      const data = (await center.service.post("/login/signin", { username, password })).data
      token = data.token
      user = data.user
    } catch (error) {
      const { message } = error
      Message({
        type: "error",
        message,
      })
    }
    if (!token || !user) return
    const { roles } = user
    const isNext = roles.includes("owner") || roles.includes("superadmin") || roles.includes("appstore_admin")
    if (!isNext) {
      Message({
        type: "error",
        message: "该账号无权限管理该平台",
      })
      LazycatAccountCenter.ClearToken()
      return false
    }
    LazycatAccountCenter.saveToken(token)
    return user
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      removeToken()
      resolve()
    })
  },

  // user logout
  async logout({ commit }) {
    await center.signout()
  },

  async current({ commit }) {
    const data = await center.current()
    data.id = String(data.id)
    commit('SET_ID', data.id)
    commit('SET_NAME', data.nickname)
    commit('SET_AVATAR', data.avatar)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
